import { SelectInput } from '@framework/form/inputs/SelectInput.tsx';
import { type IWidgetComponentProps } from '../../../../IWidgetType.ts';
import { useSelectOptions } from '../../common/option-list/hooks/useSelectOptions.ts';
import { getWidgetProps } from '../../common/util/getWidgetProps.ts';
import { type IUseSingleSelectWidgetOptionsReturn } from '../hooks/useSingleSelectWidgetOptions.tsx';
import { type ISingleSelectWidget } from '../ISingleSelectWidget.ts';

export interface ISingleSelectSelectComponentProps
  extends IWidgetComponentProps<ISingleSelectWidget>,
    IUseSingleSelectWidgetOptionsReturn {}

/**
 * Componente principale del widget select in caso di scelta di menù a tendina.
 */
export function SingleSelectSelectComponent(
  props: ISingleSelectSelectComponentProps,
) {
  const { options, componentOptions } = props;

  const widgetOptions = getWidgetProps(props);

  const selectOptions = useSelectOptions(componentOptions, widgetOptions);

  return (
    <SelectInput
      readOnly={props.readonly}
      name={widgetOptions.name}
      options={selectOptions}
      group={componentOptions.type === 'grouped'}
      optionFilterProp="labelText"
      allowClear
      placeholder={
        widgetOptions.placeholder
          ? widgetOptions.placeholder
          : widgetOptions.preview
            ? 'Placeholder'
            : ''
      }
      // per accessibilità limitiamo virtual a 20 opzioni
      showSearch={true}
      virtual={selectOptions.length > 20}
      popupMatchSelectWidth
    />
  );
}
